function getDefaultState() {
  return {
    carrinho: {
      carregado: false,
      CASAS_DECIMAIS_CARRINHO: 4,
      COMPRA_MULTIFILIAIS: 'N',
      headers: {},
      showImagemProduto: false
    }
  }
}

const state = getDefaultState();

const getters = {
  carrinho(state) {
    return state.carrinho;
  }
};

const mutations = {
  setCarrinho(state, novo) {
    state.carrinho = novo;
  },
  setHeader(state, index) {
    state.carrinho.headers[index] = !state.carrinho.headers[index];
  },
};

const actions = {
  setCarrinho: ({ commit }, novo) => {
    commit('setCarrinho', novo);
  },
  setHeader: ({ commit }, index) => {
    commit('setHeader', index);
  },
};

export default { namespaced: true, state, mutations, getters, actions };
